import { render } from "./OverlayLogin.vue?vue&type=template&id=527950f0&scoped=true"
import script from "./OverlayLogin.vue?vue&type=script&lang=js"
export * from "./OverlayLogin.vue?vue&type=script&lang=js"

import "./OverlayLogin.vue?vue&type=style&index=0&id=527950f0&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527950f0"]])

export default __exports__